<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_payment_method_banner.jpg')" alt="入出金方法">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="sup-page-title">
          入出金方法
        </h1>
        <p class="sup-page-lead">
          勝WINでは、多彩な入出金方法をご用意しており、<br>
          特に10種類以上の仮想通貨でのご入出金に対応しております。<br>
          また、各入金方法に対応した出金手続きも非常に簡単に行えます。
        </p>
        <div class="sup-listbox">
          <p class="sup-listbox-title">
            入金方法一覧
          </p>
          <div class="sup-listbox-list">
            <router-link class="sup-list-btn" to="/page/sup-deposit-bank">
              <span>銀行振込</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
            <router-link class="sup-list-btn" to="/page/sup-deposit-mtpay">
              <span>Match Pay</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
            <router-link class="sup-list-btn" to="/page/sup-deposit-vega">
              <span>VegaWallet</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
            <router-link class="sup-list-btn" to="/page/sup-deposit-jeten">
              <span>Jetonbank</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
            <router-link class="sup-list-btn" to="/page/sup-deposit-usdt">
              <span>USDT購入</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
            <router-link class="sup-list-btn" to="/page/sup-deposit-crypto">
              <span>仮想通貨</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
          </div>
        </div>
        <div class="sup-listbox sup-listbox--mt">
          <p class="sup-listbox-title">
            出金方法一覧
          </p>
          <div class="sup-listbox-list">
            <router-link class="sup-list-btn" to="/page/sup-withdraw-bank">
              <span>銀行振込</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
            <router-link class="sup-list-btn" to="/page/sup-withdraw-mtpay">
              <span>Match Pay</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
            <router-link class="sup-list-btn" to="/page/sup-withdraw-vega">
              <span>VegaWallet</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
            <router-link class="sup-list-btn" to="/page/sup-withdraw-jeton">
              <span>Jetonbank</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
            <router-link class="sup-list-btn" to="/page/sup-withdraw-crypto">
              <span>仮想通貨</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'payment-method',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
